import apiClient from 'api/apiClient';
import { ApiResponse, Alarm } from 'types';
import API_END_POINT from 'constants/apiEndPoints';

interface FetchAlarmResponse extends ApiResponse {
  updatedAlarm: boolean;
  alarmList: {
    [alarmId: string]: Alarm;
  };
}

type FetchAlarm = () => Promise<FetchAlarmResponse>;

const fetchAlarm: FetchAlarm = async () => {
  const { data } = await apiClient.get(API_END_POINT.USER.FETCH_ALARM);

  return data;
};

export default fetchAlarm;
